

import Vue from 'vue'
import App from './App'
import router from './router'
import rem from './util/rem'
import commonCss from './style/common.css'
import commonJs from './util/common.js'
import tabVerify from './util/tabVerify.js'
import $ from 'jquery'
import Api from './api/api.js'
import Alert from 'vux/src/components/alert/index.vue'

import echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.component('alert', Alert)
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)
Vue.use(Api)
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.prototype._Api = Api
Vue.config.productionTip = false
Vue.use(commonJs)
Vue.use(tabVerify)
Vue.prototype.BM = commonJs;
Vue.prototype.TV = tabVerify;
import clipboard from 'clipboard';

Vue.prototype.clipboard = clipboard;
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js